var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.ready)?_c('progress-bar'):_c('SupervisorReportManagerWrapper',{attrs:{"querylogs":_vm.querylogs,"persistanceLogs":_vm.persistanceLogs,"workers":_vm.workers}})
}
var staticRenderFns = []

export { render, staticRenderFns }